export const SESSION_PARENT_ENTITY = {
  ORGANIZATION: 'organization',
  EVENT: 'event',
} as const;

export type SessionParentEntity = (typeof SESSION_PARENT_ENTITY)[keyof typeof SESSION_PARENT_ENTITY];
